import React from 'react';
import './Sub-services.css';
import OffGrid from './assets/off-grid.PNG';

const OffGridContent = () => {
  return (
    <div className='containerSer'>
      <h2>Sistemas Fotovoltaicos OFF GRID</h2>
      <p>
        Los sistemas solares fotovoltaicos no conectados a la red (OFF-GRID)
        generan electricidad a partir de la energía solar, pero a diferencia de
        los sistemas conectados a la red, funcionan de manera autónoma gracias a
        un banco de baterías que almacena la energía para su uso cuando se
        necesite. No dependen del suministro eléctrico convencional, por lo que
        son ideales para zonas rurales o lugares con servicio eléctrico
        inestable o inexistente.
      </p>
      <p>
        Ofrecemos el servicio de diseño, suministro e instalación de sistemas
        solares Off Grid, ajustados a las necesidades específicas de cada
        cliente en zonas rurales, fincas o viviendas sin acceso a la red
        eléctrica o con suministro inestable. Este servicio te incluye: estudio
        del consumo energético, diseño del sistema solar con almacenamiento
        mediante baterías, suministro e instalación de paneles solares,
        inversores, baterías y sistemas de protección; capacitación para el uso
        adecuado del sistema y soporte técnico.
      </p>
      <div className="image">
        <img src={OffGrid} alt="Sistema Off-grid" />
      </div>

      <h3>Beneficios clave:</h3>
      <ul>
        <li>Tienes mayor independencia energética.</li>
        <li>Reduces costos frente a otras fuentes de energía.</li>
        <li>No tienes facturación mensual de energía.</li>
        <li>
          Contribuyes al cuidado del medio ambiente mediante energía limpia.
        </li>
        <li>
          Tienes la tranquilidad total, al delegar tu sistema a profesionales.
        </li>
      </ul>
    </div>
  );
};

export default OffGridContent;
